
import { AppFirebase, firebase} from '../../config/firebase.js';
import { useEffect, useState } from 'react';
import { collection, getDocs, getFirestore, orderBy, query, where } from 'firebase/firestore';

import * as C from './styles';
import { useNavigate, useParams } from 'react-router-dom';
import NewProfile from './components/new-profile';
import DeleteProfile from './components/delete-profile';
import Logo from '../../components/images/logo.png';

export default function Profiles() {

    const { profileSettings } = useParams();

    const [ user, setUser ] = useState({});
    const [ profiles, setProfiles ] = useState([]);

    const [ newProfile, setNewProfile ] = useState(profileSettings == 'new');
    const [ manageProfiles, setManageProfiles ] = useState(profileSettings == 'manage');
    const [ deleteProfile, setDeleteProfile ] = useState({});

    const [ loadingPage, setLoadingPage ] = useState(true);
    const [ loadingProfiles, setLoadingProfiles ] = useState(true);
    
    const database = getFirestore(AppFirebase);

    const navigate = useNavigate();
    
    useEffect(()=> {
        window.scrollTo(0,0)
    }, [ ]);

    useEffect(() => {
        firebase.auth().onAuthStateChanged(async (user) => {
            if (user) {
                setUser(user);
                getProfiles(user.uid);
            } else {
                navigate('/login')
            }
        });

        document.title = 'Moov Pro'
    }, [ ]);

    useEffect(() => {
        if (user && user.uid) {
            getProfiles(user.uid);
        }
    }, [ user ]);

    const getProfiles = async (uid) => {
        try {
            const q = query(
                collection(database, `profiles`),
                where('account_uid', '==', uid),
                orderBy('profile_created', 'asc')
            );
            
            const querySnapshot = await getDocs(q);
    
            // Verifique se há documentos antes de mapear
            if (!querySnapshot.empty) {
                const profilesData = querySnapshot.docs.map(doc => doc.data());
                setProfiles(profilesData);
            }
        } catch (error) {
        } finally {
            setLoadingPage(false);
            setTimeout(() => {
                setLoadingProfiles(false);
            }, 100);
        }
    };

    const defineProfile = (profile)=> {
        
        localStorage.setItem('profile_uid', profile.profile_uid);
        navigate('/');
        window.location.reload();

    }
    
    const redirectEditProfile = (profile) => {
        defineProfile(profile)
        navigate('/settings/edit-profile/manage=profile');
    }
    
    const cancelNewProfile = () => {
        setNewProfile(false)
        if (profileSettings) {
            navigate('/settings/account');
        }
    }
    
    const cancelManageProfile = () => {
        setManageProfiles(!manageProfiles);
        if (profileSettings) {
            navigate('/settings/account');
        }
    }
    
    return (
        <C.Container>
            {/* tela carregamento */}
            {(loadingPage) &&
                <div className="loader-container">
                    <img src={Logo}/>
                    <div className="loader">
                        <div></div>
                        <div></div>
                    </div>
                </div>
            }
            <C.Content loadingProfiles={loadingProfiles}>
                {((!profileSettings || profileSettings == 'manage') && (profiles && (profiles.length >= 1) && !newProfile && !deleteProfile.profile_uid)) &&
                    <>
                        <h2 className='title-welcome'>Seja bem vindo(a)!</h2>
                        <C.Profiles>
                            {profiles.map((profile, key)=> {
                                return(
                                    <C.Profile key={key} disabled={manageProfiles}>
                                        <button onClick={()=> !manageProfiles && defineProfile(profile)} className='profile'>
                                            <div className='div-img-profile'>
                                                <img src={profile.profile_photo_url ? profile.profile_photo_url : 'https://dflix.netlify.app/imagens/img-avatar.png'} onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src="https://dflix.netlify.app/imagens/img-avatar.png";}} />
                                                {(manageProfiles) &&
                                                    <button className='edit-profile' onClick={()=>redirectEditProfile(profile)}><i className="fas fa-edit"></i></button>
                                                }
                                            </div>
                                            <p className='name'>{profile.profile_name}</p>
                                        </button>
                                        <div>
                                            {(manageProfiles && !profile.profile_primary) &&
                                                <button className='delete-profile' onClick={()=>setDeleteProfile(profile)}><i className="fas fa-trash-can"></i> Excluir</button>
                                            }
                                        </div>
                                    </C.Profile>
                                )
                            })}
                            {(profiles.length < 4 && !manageProfiles) &&
                            <div className='div-add-profile'>
                                <button className='add-profile' onClick={()=>setNewProfile(true)}>
                                    <i className="fa-solid fa-plus"></i>
                                    <span>Novo Perfil</span>
                                </button>
                            </div>
                            }
                        </C.Profiles>
                        {(profiles.length > 3 && !manageProfiles) &&
                            <div className='number-profiles'>
                                <span>Perfis ({profiles.length}/4)</span>
                            </div>
                        }
                        <div className='footer-profiles'>
                            {profiles.length >= 1 &&
                                <button onClick={cancelManageProfile}>{manageProfiles ? 'Cancelar' : 'Gerenciar Perfis'}</button>
                            }
                            {/*!manageProfiles &&
                                <button onClick={()=>setLogout(true)}>Sair</button>
                            */}
                        </div>
                    </>
                }
                {!loadingProfiles && (newProfile || (profiles && profiles.length == 0)) &&
                    <NewProfile profileSettings={profileSettings} cancelNewProfile={cancelNewProfile} user={user} getProfiles={getProfiles} newProfile={newProfile} setNewProfile={setNewProfile} profilesLength={profiles.length}/>
                }
                {(deleteProfile.profile_uid && user?.uid) &&
                    <DeleteProfile user={user} profile={deleteProfile} setUser={setDeleteProfile} getProfiles={getProfiles} userUid={user.uid} setManageProfiles={setManageProfiles}/>
                }
            </C.Content>
        </C.Container>
    )

}